/* Contoured Nutrition Shopify Theme v1.0 (jQuery 1.4.1 required). Copyright (c) Pixellent, LLC <http://www.pixellent.com>. */

/**
* @package Quimbee
*/
$(document).ready(function() {

	// External links in new windows
	$('a[rel=external]').click(function() {
		window.open($(this).attr('href'));
		return false;
	});

	// Primary nav
	$('#header > ul').hover(function() {
		$(this).find('.active').removeClass('hover');
	}, function() {
		$(this).find('div.active').addClass('hover');
	});
	$('#header > ul li').hover(function() {
		$(this).find('div,ul').addClass('hover');
		if($(this).find('div').hasClass('active')) {
			return false;
		}
	}, function() {
		$(this).find('div,ul').removeClass('hover');
	});

	// Highlight current nav
	if(self.location.pathname.match(/\/product/i)) {
		var re = new RegExp('/collections/all', 'i');
	}
	else if(self.location.pathname.match(/\/blogs\/news/i)) {
		var re = new RegExp('/blogs/news', 'i');
	}
	else {
		var re = new RegExp(self.location.pathname, 'i');
	}
	var isHome = self.location.pathname.replace(/\//gi, '')=='';
	var found = false;
	$('#header > ul li div a').each(function(i, el) {
		if((isHome && i==0) || (!isHome && $(this).attr('href').match(re))) {
			$(this).parents('li').find('div,ul').addClass('active');
			$(this).parents('li').find('div').addClass('hover');
			found = true;
		}
	});
	if(!found) {
		$('#header > ul li > ul a').each(function(i, el) {
			if($(this).attr('href').match(re)) {
				$(this).parent('li').parents('li').find('div,ul').addClass('active');
				$(this).parent('li').parents('li').find('div').addClass('hover');
				found = true;
			}
		});
	}

	// Setup randomized elements.
	// To randomize the children of an element, add a "random" class to that parent
	// element, and a "random-X" rel attribute where "X" is the no. children to
	// make visible.
	$('.random').each(function(i, el) {
		var parent = $(el);
		var max = parseInt(parent.attr('rel').replace(/.*random\-([0-9]+)/, "$1"));
		var children = parent.children().css('display', 'none');
		var numbers = [];
		for(var ni=0; ni<children.size(); ni++) {
			numbers.push(ni);
		}
		for(ni=numbers.length-1; ni>0; ni--) {
			var r = Math.round(Math.random()*ni);
			var t = numbers[ni];
			numbers[ni] = numbers[r];
			numbers[r] = t;
		}
		numbers = numbers.slice(0, max);
		for(ni=0; ni<numbers.length; ni++) {
			$(children.get(numbers[ni])).css('display', 'block');
		}
		parent.css('display', 'block');
	});

	// Add hovering mechanics to the product nodes in a collection
	$('ul.collection li div.info').css({opacity: 0, display: 'block'});
	$('ul.collection li').hover(function() {
		$(this).find('div.info').stop().animate({opacity: 1}, 'fast');
	}, function() {
		$(this).find('div.info').stop().animate({opacity: 0}, 'fast');
	});

	// Add hover mechanics to buttons
	$('button[rel=hashover]').hover(function() {
		$(this).addClass('hover');
	}, function() {
		$(this).removeClass('hover');
	});

	// Ensure right-column fills height
	var rc = $('div.right-column');
	/*if(rc.size()>0) {
		var c = rc.children();
		var h = 0;
		c.each(function(i, el) {
			h += $(el).height();
		});
		rc.height(h);
		$('#body .body-inner').addClass('with-right-column');
	}*/

	// Mailing list mechanics
	var ml = $('#f-search input');
	ml.data('originalval', ml.val()).focus(function() {
		var t = $(this);
		if(t.val()==t.data('originalval')) {
			t.val('');
		}
	}).blur(function() {
		var t = $(this);
		if(t.val()=='') {
			t.val(t.data('originalval'));
		}
	});

	// Fix image sizes in collection lists
	$('ul.collection li .img img').each(function(i, el) {
		if($(el).width()>225) {
			$(el).width(225);
		}
	});

	// Setup page
	switch($(document.body).attr('class')) {
		case 'body-index':
			initIndex();
			break;
		case 'body-page.contact':
			initPageContact();
			break;
		case 'body-product':
			initProduct();
			break;
		default:
			break;
	}
});

$(window).load(function() {

	// Place footer on bottom of page
	var wb = $('#body');
	var wf = $('#wrap-footer');
	var ft = parseInt(wf.position().top);
	var dh = $(window).height();
	if(ft+wf.height()<dh) {
		wb.height(wb.height()+(dh-(ft+wf.height())));
	}
});

function initIndex() {

	// Slide show
	window.__slideCurrent = 0;
	$('#slide-container div.slide').each(function(i, el) {
		$(el).css({opacity: i==window.__slideCurrent ? 1 : 0});
	});
	var t = setInterval(tSlide, 5000);
}

function tSlide() {
	var slideNext = (window.__slideCurrent+1)%$('#slide-container div.slide').size();
	$($('#slide-container div.slide').get(window.__slideCurrent)).animate({opacity:0}, 500);
	$($('#slide-container div.slide').get(slideNext)).animate({opacity:1}, 500);
	window.__slideCurrent = slideNext;
}



function initPageContact() {

	// Add hover mechanics to buttons
	$('input.fsSubmitButton').hover(function() {
		$(this).addClass('hover');
	}, function() {
		$(this).removeClass('hover');
	});
}

/**
* Init product page.
*
* @return void
*/
function initProduct() {

	// Init product switch
	$('#product-thumbs li a').each(function(i, el) {
		$($('#product-featured ul li').get(i)).css({opacity: i==0 ? 1 : 0});
		$(el).data('thumb-index', i).click(function() {
			var featured = $('#product-featured ul li');
			var thumbIndex = $(this).data('thumb-index');
			for(var i=0; i<featured.length; i++) {
				$(featured.get(i)).stop().animate({opacity: i==thumbIndex ? 1 : 0}, 1000);
			}
			return false;
		});
	});

	// Add hover mechanics to "add" button
	$('#btn_add').hover(function() {
		$(this).addClass('hover');
	}, function() {
		$(this).removeClass('hover');
	});

	// Resize larger featured images
	$('#product-featured .img img').each(function(i, el) {
		if($(el).width()>413) {
			$(el).width(413);
		}
	});
}

/**
* Used in product template.
* Triggered when a variant is selected
*
* @return void
*/
function variantSelectCallback(variant, selector) {
	if (variant && variant.available == true) {
		// selected a valid variant
		$('p.product-unavailable').css('display', 'none');
		$('#btn_add').attr('disabled', '');           // reenable add-to-cart button
		$('#price').html(Shopify.formatMoney(variant.price, window.money_without_currency_format));  // update price field
	} else {
		// variant doesn't exist
		$('p.product-unavailable').css('display', 'block');
		$('#btn_add').attr('disabled', 'disabled');              // disable add-to-cart button      
		$('#price').html((variant) ? "Sold Out" : "Unavailable"); // update price-field message
	}
}